"use strict";
var Observable_1 = require("../../Observable");
var windowTime_1 = require("../../operator/windowTime");
Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
//# sourceMappingURL=windowTime.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/windowTime.js
 ** module id = 437
 ** module chunks = 1
 **/